import { defineMessages } from "@/i18n";
import en from "./en";

export const libChatMessages = defineMessages("lib-chat", en);
